import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { fadeInUpOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { UpfrontPaymentSliderComponent } from '../../shared/components/upfront-payment-slider/upfront-payment-slider.component';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  animations:[
    fadeInUpOnEnterAnimation({ anchor: 'enter', duration: 1000, delay: 500, translate: '100px' }),
    fadeOutOnLeaveAnimation({ anchor: 'leave', duration: 1000, delay: 300 })
  ]
})
export class PageComponent implements OnInit {
  @ViewChild('UpfrontPaymentSliderComponent') UpfrontPaymentSliderComponent!: UpfrontPaymentSliderComponent;


  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
        this.refreshSection();

  }
  
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.refreshSection();
    }, 100);
  }
  refreshSection() {
    if (this.UpfrontPaymentSliderComponent) {
      this.UpfrontPaymentSliderComponent.refresh();
      this.cdr.detectChanges(); 

    }
  }
}
